export default "__VITE_ASSET__CBnKmq0$__"